var e={SelectButton:"SelectButton__SelectButton-xX-",isSelected:"SelectButton__isSelected-zcL"};export{e as default};
